import React, { FC, useMemo } from "react";
import {
  QuestionComponentType,
  QuestionConfigDetailDto,
} from "@green0meter/api-client";

import { Chip } from "@components/common";
import { Box, Dropdown } from "@components/base";
import { isNumber } from "@helpers";
import { QUESTION_DATA_TYPE_MAP } from "@constants";
import { useQuestionEditorStore } from "@components/main/questions/QuestionEditor";

interface QuestionTypeSelect {
  questionConfig: QuestionConfigDetailDto;
  setQuestionConfig: (config: QuestionConfigDetailDto) => void;
  filter?: QuestionComponentType[];
}

const QuestionTypeSelect: FC<QuestionTypeSelect> = ({
  questionConfig,
  setQuestionConfig,
  filter,
}) => {
  const { newQuestionConfig } = useQuestionEditorStore();
  const editMode = !!newQuestionConfig?.id;

  const handleChangeComponentType = (componentType: QuestionComponentType): void => {
    const dataType = QUESTION_DATA_TYPE_MAP[componentType];

    if (dataType !== undefined && questionConfig) {
      setQuestionConfig({
        ...questionConfig,
        componentType,
        dataType,
      });
    }
  };

  const options = useMemo(() => {
    const keys = Object.keys(QuestionComponentType).filter(
      (k) =>
        !isNumber(k) &&
        (!filter ||
          filter.includes(
            QuestionComponentType[k as keyof typeof QuestionComponentType],
          )),
    );

    return keys.map((k) => ({
      id: k,
      title: <Chip label={k} type={k} size="small" />,
    }));
  }, []);

  return questionConfig ? (
    <Box>
      {editMode && (
        <Chip
          label={QuestionComponentType[questionConfig.componentType]}
          type={QuestionComponentType[questionConfig.componentType]}
          size="small"
        />
      )}
      {!editMode && (
        <Dropdown
          button={{
            title: (
              <Chip
                label={QuestionComponentType[questionConfig.componentType]}
                type={QuestionComponentType[questionConfig.componentType]}
                size="small"
              />
            ),
            variant: "text",
            size: "small",
          }}
          options={options}
          onSelect={(option) =>
            handleChangeComponentType(
              QuestionComponentType[option.id as keyof typeof QuestionComponentType],
            )
          }
        />
      )}
    </Box>
  ) : null;
};

export default QuestionTypeSelect;
